import { useTheme } from "../../theme/ThemeContext";

const VARIANTS = {
  white: "/assets/logos/ONIX_logo_primary_white_transparent.png",
  silver: "/assets/logos/ONIX_logo_primary_silver_on_black.png",
  blackOnWhite: "/assets/logos/ONIX_logo_black_on_white.png",
};

export const ShieldMark = ({ variant = "white", className = "", alt = "Escudo ONIX — Intelligence and Cybersecurity Systems", eager = false }) => {
  const themeCtx = useTheme();
  const isLight = themeCtx?.theme === "light";
  const invertible = variant === "white" || variant === "silver";
  const src = isLight && invertible ? VARIANTS.white : VARIANTS[variant];
  const invert = isLight && invertible ? " logo-invert" : "";
  return (
    <img
      data-testid="shield-mark"
      src={src}
      alt={alt}
      className={`block h-auto select-none${invert} ${className}`}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      draggable="false"
    />
  );
};
